export default "__VITE_ASSET__CsWftVvX__"